module.exports = __webpack_public_path__ + "img/production-dark.34b1d5e7.svg";